export const STATUS_OPEN = 'open';
export const STATUS_CLOSED = 'closed';
export const STATUS_ALL = 'all';
